<template>
  <span class="ml-2">

    <!-- Below tolerance -->
    <span
        v-if="
          getSelectedRisk(confidentialityImpact, confidentialityProbability) <= this.confidentialityTolerance.number &&
          getSelectedRisk(integrityImpact, integrityProbability) <= this.integrityTolerance.number &&
          getSelectedRisk(availabilityImpact, availabilityProbability) <= this.availabilityTolerance.number &&
          (this.confidentialityImpact && this.confidentialityImpact.value) &&
          (this.confidentialityProbability && this.confidentialityProbability.value) &&
          (this.integrityImpact && this.integrityImpact.value) &&
          (this.integrityProbability && this.integrityProbability.value) &&
          (this.availabilityImpact && this.availabilityImpact.value) &&
          (this.availabilityProbability && this.availabilityProbability.value)
        "
    >
      <span class="badge-pill badge-success mr-1">
        <font-awesome-icon icon="check" size="xs"/>
      </span>
      {{ $t('risk.below_tolerance') }}
    </span>

    <!-- Above tolerance -->
    <span
        v-if="
        (
          getSelectedRisk(confidentialityImpact, confidentialityProbability) > this.confidentialityTolerance.number ||
          getSelectedRisk(integrityImpact, integrityProbability) > this.integrityTolerance.number ||
          getSelectedRisk(availabilityImpact, availabilityProbability) > this.availabilityTolerance.number
        ) &&
        (this.confidentialityImpact && this.confidentialityImpact.value) &&
        (this.confidentialityProbability && this.confidentialityProbability.value) &&
        (this.integrityImpact && this.integrityImpact.value) &&
        (this.integrityProbability && this.integrityProbability.value) &&
        (this.availabilityImpact && this.availabilityImpact.value) &&
        (this.availabilityProbability && this.availabilityProbability.value)
        "
    >
      <span class="badge-pill badge-danger mr-1">
        <font-awesome-icon icon="times" size="xs"/>
      </span>
      {{ $t('risk.above_tolerance') }}
    </span>

    <!-- Missing input -->
    <span class="mr-1"
          v-if="
            (this.confidentialityImpact && !this.confidentialityImpact.value) ||
            (this.confidentialityProbability && !this.confidentialityProbability.value) ||
            (this.integrityImpact && !this.integrityImpact.value) ||
            (this.integrityProbability && !this.integrityProbability.value) ||
            (this.availabilityImpact && !this.availabilityImpact.value) ||
            (this.availabilityProbability && !this.availabilityProbability.value)
          "
    >
      <font-awesome-icon
          icon="exclamation-triangle"
          :class="'risk-9'"
      />
      {{ $t('risk.missing_input') }}
    </span>


    <!-- No risk tolerance -->
    <!-- <span v-if="this.confidentialityTolerance && !this.confidentialityTolerance.number && this.integrityTolerance && !this.integrityTolerance.number && this.availabilityTolerance && !this.availabilityTolerance.number" class="ml-1">
      {{ $t('system.n_a') }}
    </span> -->

  </span>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'RealtimeRiskCia',
    data: function() {
      return {
        confidentialityTolerance: {},
        integrityTolerance: {},
        availabilityTolerance: {},
      }
    },
    props: {
      confidentialityImpact: {
      },
      confidentialityProbability: {
      },
      integrityImpact: {},
      integrityProbability: {
      },
      availabilityImpact: {
      },
      availabilityProbability: {
      },
      cTolerance: {},
      iTolerance: {},
      aTolerance: {},
      riskCategory: {}
    },
    components: {

    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      },

    },
    methods: {
      getSelectedRisk(impact, probability) {
        if (impact.value && impact.value == 'Very high' && probability.value && probability.value == 'Very unlikely') {
          return 4
        }
        if (impact.value && impact.value == 'Very high' && probability.value && probability.value == 'Unlikely') {
          return 8
        }
        if (impact.value && impact.value == 'Very high' && probability.value && probability.value == 'Likely') {
          return 12
        }
        if (impact.value && impact.value == 'Very high' && probability.value && probability.value == 'Very likely') {
          return 16
        }

        if (impact.value && impact.value == 'High' && probability.value && probability.value == 'Very unlikely') {
          return 3
        }
        if (impact.value && impact.value == 'High' && probability.value && probability.value == 'Unlikely') {
          return 6
        }
        if (impact.value && impact.value == 'High' && probability.value && probability.value == 'Likely') {
          return 9
        }
        if (impact.value && impact.value == 'High' && probability.value && probability.value == 'Very likely') {
          return 12
        }

        if (impact.value && impact.value == 'Low' && probability.value && probability.value == 'Very unlikely') {
          return 2
        }
        if (impact.value && impact.value == 'Low' && probability.value && probability.value == 'Unlikely') {
          return 4
        }
        if (impact.value && impact.value == 'Low' && probability.value && probability.value == 'Likely') {
          return 6
        }
        if (impact.value && impact.value == 'Low' && probability.value && probability.value == 'Very likely') {
          return 8
        }

        if (impact.value && impact.value == 'Very low' && probability.value && probability.value == 'Very unlikely') {
          return 1
        }
        if (impact.value && impact.value == 'Very low' && probability.value && probability.value == 'Unlikely') {
          return 2
        }
        if (impact.value && impact.value == 'Very low' && probability.value && probability.value == 'Likely') {
          return 3
        }
        if (impact.value && impact.value == 'Very low' && probability.value && probability.value == 'Very likely') {
          return 4
        }
      }
    },
    created () {

      if (this.cTolerance && !this.cTolerance.number) {
        this.confidentialityTolerance.number = 0
      } else {
        this.confidentialityTolerance = this.cTolerance
      }

      if (this.iTolerance && !this.iTolerance.number) {
        this.integrityTolerance.number = 0
      } else {
        this.integrityTolerance = this.iTolerance
      }

      if (this.aTolerance && !this.aTolerance.number) {
        this.availabilityTolerance.number = 0
      } else {
        this.availabilityTolerance = this.aTolerance
      }

    }
  }
</script>
